import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { EGender } from '@sharedInterfaces/IEmployee';
import { getLanguageTexts } from '@sharedInterfaces/Language/languageHelper';
import type { AppState } from '@store/store';
import React from 'react';
import { useSelector } from 'react-redux';

interface GenderSelectProps {
    value: EGender;
    disabled?: boolean;
    onChange?: (val: EGender) => void;
}

const GenderSelect: React.FC<GenderSelectProps> = ({ value, disabled, onChange }) => {
    const lang = useSelector((state: AppState) => state.employee.language);
    const langStrings = getLanguageTexts(lang).userDialog;

    return (
        <FormControl component="fieldset">
            <RadioGroup
                row
                aria-label="gender"
                name="gender"
                value={value}
                onChange={(e) => (onChange ? onChange(e.target.value as EGender) : undefined)}
            >
                <FormControlLabel
                    value={EGender.FEMALE}
                    control={<Radio disabled={disabled} />}
                    label={langStrings.female}
                />
                <FormControlLabel
                    value={EGender.MALE}
                    control={<Radio disabled={disabled} />}
                    label={langStrings.male}
                />
                <FormControlLabel
                    value={EGender.OTHER}
                    control={<Radio disabled={disabled} />}
                    label={langStrings.other}
                />
            </RadioGroup>
        </FormControl>
    );
};

export default GenderSelect;
